// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__st7Zp","list":"Footer_list__1QJ4w","contact":"Footer_contact__8nNuz","copy":"Footer_copy__33kv9"};